<script lang="ts" setup>
import { ref, Ref, computed } from 'vue';
import properties from '@/components/forms/properties';
import { RootEntry } from '@/components/builder/form/entries/RootEntry';
import { instanceOfPersonalEntry, PersonalType, PersonalEntry } from '.';
import { FormBuilderContract } from '@/components/builder/form';
import { AggregateBlueprint } from '@/components/builder/base/blueprints/AggregateBlueprint';

defineOptions({
    name: 'personal-blueprint',
    components: {
        ...properties
    }
});

const props = defineProps({
  "blueprint": null,
  "entry": null,
  "form": null,
  "parent": null,
  "index": null
});
const blueprint = computed(() => props.blueprint);

const entryData = ref(new PersonalEntry()) as Ref<PersonalEntry>;

entryData.value = props.form.document.initEntry(props.blueprint, entryData.value, instanceOfPersonalEntry, props.index);

const title = computed({
    get()
    {
        return entryData.value.data.title;
    },
    set(value: string)
    {
        entryData.value.data.title = value;
    }
});

const givenName = computed({
    get()
    {
        return entryData.value.data.givenName;
    },
    set(value: string)
    {
        entryData.value.data.givenName = value;
    }
});

const middleName = computed({
    get()
    {
        return entryData.value.data.middleName;
    },
    set(value: string)
    {
        entryData.value.data.middleName = value;
    }
});

const surname = computed({
    get()
    {
        return entryData.value.data.surname;
    },
    set(value: string)
    {
        entryData.value.data.surname = value;
    }
});

const readonly = computed(() => props.form.expressions.readonly(props.blueprint));
const required = computed(() => props.form.expressions.required(props.blueprint));
</script>

<template>
    <form-component-wrapper class="personal-component" :form="form" :parent="parent" :blueprint="blueprint">
        <template #default>
            <div class="form-group">
                <form-label :form="form" :blueprint="blueprint" :required="required" :entry="entryData" />
                <div class="row g-0">
                    <div class="col-2 pe-2" v-if="blueprint.hasTitle">
                        <input type="text" class="form-control" v-model="title" :placeholder="$t('[[[Tytuł]]]')" :readonly="readonly">
                    </div>
                    <div class="col pe-2">
                        <input type="text" class="form-control" v-model="givenName" :placeholder="$t('[[[Imię]]]')" :readonly="readonly">
                    </div>
                    <div class="col pe-2" v-if="blueprint.hasMiddleName">
                        <input type="text" class="form-control" v-model="middleName" :placeholder="$t('[[[Drugie imię]]]')" :readonly="readonly">
                    </div>
                    <div class="col">
                        <input type="text" class="form-control" v-model="surname" :placeholder="$t('[[[Nazwisko]]]')" :readonly="readonly">
                    </div>
                </div>
                <form-error-message :entry="entryData" name="title" />
                <form-error-message :entry="entryData" name="givenName" />
                <form-error-message :entry="entryData" name="middleName" />
                <form-error-message :entry="entryData" name="surname" />
                <form-error-message :entry="entryData" name="custom" />
                <form-help :form="form" :blueprint="blueprint" />
            </div>
        </template>
        <template #properties>
            <field-name :form="form" :blueprint="blueprint" v-model="blueprint.name" />
            <ideo-form-localize v-slot="{ locale }">
                <field-text v-model="blueprint.label[locale]" :label="$t('[[[Etykieta]]]')" />
            </ideo-form-localize>
            <field-checkbox v-model="blueprint.showLabel" :label="$t('[[[Pokaż etykietę]]]')" />
            <h6>{{ $t('[[[Pole zawiera]]]') }}</h6>
            <field-checkbox v-model="blueprint.hasTitle" :label="$t('[[[Tytuł]]]')" />
            <field-checkbox v-model="blueprint.hasMiddleName" :label="$t('[[[Drugie imię]]]')" />
            <ideo-form-localize v-slot="{ locale }">
                <field-textarea v-model="blueprint.help[locale]" :label="$t('[[[Pomoc]]]')" />
            </ideo-form-localize>
            <field-visible :form="form" :blueprint="blueprint" />
            <field-readonly :form="form" :blueprint="blueprint" />
            <field-required :form="form" :blueprint="blueprint" />
            <field-error :form="form" :blueprint="blueprint" />
            <field-filter :form="form" :blueprint="blueprint" />
        </template>
    </form-component-wrapper>
</template>

<style lang="scss" scoped>
</style>
